import { useState } from 'react';
import { updateConditionName } from '../../../../redux/Calculations/CalculationsActions';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Tooltip } from '@mui/material';
import { fontSize, palette } from '../../../..';
import { isFlowUsed, isValidEvaluation } from '../../utils';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux';
import { useDispatch } from 'react-redux';
const ConditionName = ({
  conditionName,
  propKey,
  flowId,
  conditionUid,
  index,
  activeCondition,
}: {
  conditionName: string;
  propKey: string;
  flowId: string;
  conditionUid: string;
  index: number;
  activeCondition: number;
}) => {
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState<string>(conditionName);
  const dispatch = useDispatch();
  const calculationInfo = useSelector(
    (state: RootState) =>
      state.calculations.properties[propKey]?.currentCalculationSession?.calculationInfo,
  );
  if (!calculationInfo) return null;
  const handleEditConditionName = () => {
    dispatch(updateConditionName(propKey, flowId, conditionUid, name));
  };
  const showWarning = (): boolean => {
    if (!calculationInfo || !calculationInfo.flows[flowId]) return false;

    const condition = calculationInfo.flows[flowId].find(
      (_condition) => _condition.flowId === conditionUid,
    );
    if (!condition) return true;
    /**
     * result Type is selected and  there is something in evaluation conditions
     */
    if (condition.source.length === 0) return true;
    const filterId = condition.filter ?? '';
    if (condition.condition === 'else') return false;
    const filter = calculationInfo.conditionFilters[filterId];
    if (!filter) return true;
    if (filter[0].conditions.length === 0) return true;
    const hasInvalidCondition = filter[0].conditions.some((evaluation) => {
      const leftOperand = () => {
        if (evaluation.leftOperandType[0] === 'field')
          return calculationInfo.fields[evaluation.leftOperand[0]!].dataType;
        else {
          const flowName = calculationInfo.flows[evaluation?.leftOperand[0] as string][0].flow;
          const dataType =
            flowName === 'IfElse'
              ? calculationInfo.selectedResultType[evaluation.leftOperand[0] as string]
              : calculationInfo?.flows[evaluation.leftOperand[0] as string][0]?.resultantDatatype;

          return dataType;
        }
      };
      return !isValidEvaluation(evaluation, leftOperand()!);
    });
    return hasInvalidCondition;
  };
  return editMode ? (
    <input
      autoFocus
      style={{
        border: 'none',
        outline: 'none',
        width: '50%',
        height: '2rem',
        fontSize: fontSize.medium,
        fontWeight: 'bold',
        color: palette.primary.contrastText,
        backgroundColor: 'transparent',
      }}
      onChange={(e) => setName(e.target.value)}
      value={name}
      className="editTabSelected"
      onBlur={(e) => {
        handleEditConditionName();
        e.stopPropagation();
        setTimeout(() => setEditMode(false), 0);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleEditConditionName();
          setEditMode(false);
        }
      }}
      title="Press enter or click away to save"
    />
  ) : (
    <>
      <span
        onDoubleClick={(event) => {
          if (
            isFlowUsed(
              Object.keys(calculationInfo.flows),
              calculationInfo.flows,
              flowId,
              calculationInfo,
            )
          )
            return;
          event.stopPropagation();
          setEditMode(true);
        }}
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: fontSize.medium,
          // flexShrink: 0,
          color: palette.primary.contrastText,
        }}
      >
        {conditionName}
      </span>
      {activeCondition !== index && showWarning() ? (
        <Tooltip
          title="One or more fileds are not filled properly"
          slotProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <WarningAmberIcon
            style={{ color: 'orange', marginLeft: '5px', opacity: '0.7' }}
            fontSize="small"
          />
        </Tooltip>
      ) : null}
    </>
  );
};

export default ConditionName;
